
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.156 6.594a.527.527 0 01-.5.406c-.312 0-.562-.25-.5-.563C1.875 3.345 4.656 1 8 1c2.531 0 4.75 1.375 6 3.406V2.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5v3c0 .281-.25.5-.5.5h-3a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5h1.688A6.002 6.002 0 002.155 6.594zm11.656 2.843A.564.564 0 0114.345 9c.281 0 .531.281.469.594A7.004 7.004 0 018 15a6.956 6.956 0 01-6-3.375V13.5c0 .281-.219.5-.5.5a.494.494 0 01-.5-.5v-3c0-.25.219-.5.5-.5h3c.281 0 .5.25.5.5 0 .281-.219.5-.5.5H2.781C3.812 12.813 5.75 14 8 14a5.969 5.969 0 005.813-4.563z","fill":"#000"}}),_c('path',{attrs:{"d":"M8.508 5.313V4.75c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5v.563a2.288 2.288 0 00-.781.25c-.407.25-.72.687-.72 1.28.001.563.313.938.688 1.157.344.219.75.344 1.094.438h.063c.375.125.687.218.906.375.187.093.219.218.219.343.03.219-.063.344-.22.438-.187.125-.468.187-.75.187-.374-.031-.718-.156-1.124-.281-.094-.031-.156-.062-.219-.094-.281-.062-.562.063-.656.344a.531.531 0 00.312.625.58.58 0 01.22.063c.28.093.593.218.968.28v.532c0 .281.219.5.5.5.25 0 .5-.219.5-.5v-.531c.25-.031.531-.125.781-.281.406-.25.719-.688.719-1.282-.031-.593-.344-.968-.719-1.218A5.572 5.572 0 008.164 7.5h-.031c-.406-.125-.688-.219-.906-.344-.188-.125-.22-.218-.22-.312.001-.188.063-.313.251-.406.187-.125.469-.188.719-.188.312.031.656.094 1 .188.28.062.562-.094.625-.375a.499.499 0 00-.344-.594c-.25-.063-.5-.125-.75-.156z","fill":"#000"}})])
          )
        }
      }
    